var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLooks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#04CD58",
    d: "m19.715 11.357l-4.629-4.5H8.915l-4.629 4.5l7.714 7.5zm-2.143.214s-5.126-7.714-11.143 0c6 7.714 11.143 0 11.143 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F3FA",
    d: "M14.572 11.571a2.572 2.572 0 1 0-5.144 0a2.572 2.572 0 0 0 5.144 0m-1.286 0A1.286 1.286 0 0 0 12 10.286c-.715 0-1.285.57-1.285 1.285c0 .716.57 1.286 1.285 1.286c.716 0 1.286-.57 1.286-1.286"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLooks);
export default __webpack_public_path__ + "static/media/looks.ebaaf40017a34d7cf51f7f8400bb8a4b.svg";
export { ForwardRef as ReactComponent };